import { stringify } from "querystringify"

import { isBookingPage, isPaymentPage } from "app/AppRouter/utils"
import { basePaymentUrl } from "utils/helpers/paymentUrl"
import { useSearchParams } from "utils/customHooks"

export function useSuccessfulPaymentUrl({
    hash_id,
    booking_hash,
    deposit_hash,
    time_request_hash,
    order_hash,
}: {
    hash_id: string
    booking_hash?: string
    deposit_hash?: string
    time_request_hash?: string
    order_hash?: string
}) {
    let returnUrl = "/booking"
    const searchParams = useSearchParams()
    const params = basePaymentUrl(searchParams, hash_id)

    if (isBookingPage() && booking_hash) {
        params.booking_hash = booking_hash
    }

    if (isBookingPage() && time_request_hash) {
        params.time_request_hash = time_request_hash
    }

    if (isBookingPage() && deposit_hash) {
        params.deposit_hash = deposit_hash
    }

    if (isBookingPage() && order_hash) {
        params.order_hash = order_hash
    }

    if (booking_hash && isPaymentPage()) {
        returnUrl = `/payment/${booking_hash}`
        params.hash = booking_hash
    }

    return [document.location.origin, returnUrl, stringify(params, true)].join("")
}
